import { Dialog, DialogContent } from "@mui/material";

import ClientCommentModal from "./ClientCommentModal/ClientCommentModal";
import EditScriptModal from "./EditScriptModal.jsx/EditScriptModal";
import AppDialog from "../../ui/AppDialog";

function ScriptsAccordionModal({
  open,
  onClose,
  modalType,
  modalRef,
  modalData,
  onSubmitComment,
  onSubmitEdit,
  onDeleteScriptText,
}) {
  const renderContent = () => {
    switch (modalType) {
      // case "completed_categories":
      //   return <CompleteCategoriesModal onClose={onClose} />;
      case "client_comment":
        return (
          <ClientCommentModal
            onClose={onClose}
            modalData={modalData}
            onSubmit={onSubmitComment}
          />
        );
      case "edit_script":
        return (
          <EditScriptModal
            onClose={onClose}
            modalData={modalData}
            onSubmitEdit={onSubmitEdit}
            onDeleteScriptText={onDeleteScriptText}
          />
        );
      default:
        return null;
    }
  };

  return (
    <AppDialog open={open} onClose={onClose} ref={modalRef}>
      {renderContent()}
    </AppDialog>
  );
}

export default ScriptsAccordionModal;
